module.exports = __webpack_public_path__ + "img/img-4.2ba629af.png";